export const echoes = [
  {
    quote:
      "I greatly enjoyed this piece by 🌿 Breathe with Dawn (:D, :D) . Anything that frames pain and disappointment as signal floats right to the top of my list.",
    author: "– Russ Fee",
    link: "https://substack.com/@russfee/note/c-124541896",
  },
  {
    quote:
      "Hello Dawn, This is such a beautiful, masterfully articulated. I just fell in love with it. WOW. I could literally imagine myself in moments where I have felt like this, most of the times. It’s like you read the silent pages of my heart. I think I have not ready anything over here that resonated so much to me as this. I have subscribed, I want to read more from you. Please keep writing more.",
    author: "– Pelle",
    link: "https://substack.com/@notesfrompelle/note/c-124110393",
  },
  {
    quote:
      "I relate with so much of this — thank you for bravely sharing your story. Of stepping off the hamster wheel into something more real and true. Beautiful writing 🤍",
    author: "– Melina Charis",
    link: "https://theopenthread.substack.com/p/from-escape-to-stillness/comment/102882927",
  },
  {
    quote:
      "There is a lot of passion in your words & the way you feel TOT! I love how writing resurrected you. It did to me and I have been grateful ever since . Writing found me at my lowest and at times only writing could help me out of the sadness I was experiencing 🌸.",
    author: "– Madhumitha Priyadarshini",
    link: "https://theopenthread.substack.com/p/from-escape-to-stillness/comment/112679514",
  },
  {
    quote: "Really stuck with me 💯💗",
    author: "- Palak Jangid",
    link: "https://theopenthread.substack.com/p/a-bit-rebellious/comment/103750032",
  },
  {
    quote: "So good! Ahhhhhhhh the sweeet nectar of this rembrance 🙏🏻🕊🌹",
    author: "- Kimberly Rose Cronin",
    link: "https://theopenthread.substack.com/p/the-mind-was-born-when-we-looked/comment/112516243",
  },
  {
    quote:
      "simple truths, beautifully put, growth never asks for permission, it just carries us forward.",
    author: "- Huy Nguyen",
    link: "https://substack.com/@nnhuyhuy/note/c-114559661",
  },
  {
    quote:
      "Wow!!!! This piece is so touching! As a person, who has grown up overseas as a TCK (third culture kid), and who now lives overseas and moves every few years. It’s always so heartbreaking to let people go and to say goodbye to people. Thank you for writing such a beautiful piece!",
    author: "- Elijah Shved, Ed.S.",
    link: "https://theopenthread.substack.com/p/what-were-you-expecting/comment/115409883",
  },
  {
    quote: "Beautiful! You’re a soulful poet! 😍",
    author: "- Tracy Wright Corvo",
    link: "https://theopenthread.substack.com/p/the-mind-was-born-when-we-looked/comment/116103896",
  },
  {
    quote: "Powerful message...🙏🙏",
    author: "- VedicSoul",
    link: "https://theopenthread.substack.com/p/rooted-before-the-storm/comment/106972617",
  },
  {
    quote:
      "Woah 🔥💯 it was amazing. Your story of not giving up really inspired me. I am also new in writing.. it's great to know that you find your way in writing",
    author: "- Palak Jangid",
    link: "https://theopenthread.substack.com/p/from-escape-to-stillness/comment/103228328",
  },
  {
    quote:
      "Wow, that was beautifully written! You really have us hooked with your words!",
    author: "- Emily Richardson",
    link: "https://theopenthread.substack.com/p/from-escape-to-stillness/comment/103180485",
  },
  //   {
  //     quote:
  //       "I opened it when I was quiet overwhelmed and kind of annoyed, and it felt like a soothing breath in between the crowd of the noisy apps, like an interactive book. 😄🍃✨",
  //     author: "- A Sweet Soul",
  //     link: "https://open.substack.com/chat/posts/016993ea-66c4-4527-8628-71e0ab125cd6",
  //   },
];
